import z from 'zod';

export const salesPipelineContactStatusTriggerEnum = z.enum([
  'message_sent',
  'message_received',
  'contract_draft_created',
  'contract_sent',
  'contract_signed',
  'deposit_paid',
  'disqualified',
]);

export type SalesPipelineContactStatusTrigger = z.infer<
  typeof salesPipelineContactStatusTriggerEnum
>;
